import { render } from "./ReviewEntry.vue?vue&type=template&id=0c3abb46&ts=true"
import script from "./ReviewEntry.ts?vue&type=script&lang=ts&external"
export * from "./ReviewEntry.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__